import { createSlice } from "@reduxjs/toolkit";

const appHeaderCart = createSlice({
    name: "appHeaderCart",
    initialState: { basketCount: 0 },
    reducers: {
        incrementBasketCount(state): void {
            state.basketCount++;
        },
    },
});

const { actions, reducer } = appHeaderCart;
export const { incrementBasketCount } = actions;
export default reducer;
